<template>
  <div class="dt_wrap">
    <div class="tishi po_r success" v-if="type=='success'">
      <img src="@/assets/img/success.png" alt="" class="success_pic">
      <!-- <h1>恭喜！挑战成功</h1> -->
      <div class="flex aic jcs content">
        <div>
          <h2>{{score}}分</h2>
          <!-- <p>分值</p> -->
        </div>
      </div>
      <div class="test">
        <h6>恭喜您全答对</h6>
        <h6  v-if="drawLottery == 0">获得一次免费领取门票机会！</h6>
        <!-- ，明日再来吧 -->
        <h6  v-else>今日门票已领取成功！</h6>
      </div>
      <div class="btn flex aic jcc" @click="gobm" v-if="drawLottery == 0">
        去填写信息
      </div>
    </div>
    <div class="tishi po_r fail" v-if="type=='fail'">
      <img src="@/assets/img/fail1.png" alt="" class="fail_pic">
      <!-- <h1>不要气馁，再接再厉</h1> -->
      <div class="flex aic jcc content">
        <div>
          <h2 >{{score}}分</h2>
          <!-- <p>分值</p> -->
        </div>
      </div>
      <div class="test">
        <h6>继续加油哦！</h6>
        <h6>感谢您的参与！</h6>
      </div>
    </div>

    <div class="fxhb" @click="openshow">
      <p>获得海报</p>
    </div>

    <footer_com/>
    <!-- 报名 -->
    <van-overlay :show="showbm" z-index="9999" class-name="overlay">
      <div class="wrapper po_r">
        <p>长按图片保存</p>
        <img src="@/assets/img/close.png" alt="" class="close" @click="close">
        <div class="haibao_wrap">
          <img v-lazy="src" class="haibao" />
        </div>
      </div>
      <!-- <div class="btn_wrap flex aic jcc">
        <img src="@/assets/img/guanbi.png" alt="" class="guanbi" @click="close">
      </div> -->
    </van-overlay>

    
  </div>
</template>
<script>

import footer_com from "@/components/footer_com.vue";
export default {
  name:'Dtend',
  components: {
    footer_com
  },
  data(){
    let images = []
    for(let i=1;i<22;i++){
      images.push(`https://uploads.dahe.cn/xrf/other_images/hhb${i}.jpg`)
    }
    return {
      userWinning:0,
      type:'',
      score:0,
      userinfo:null,
      showbm:false,//是否展示报名页面
      zjinfo:{
        ifzj:false,
        drawLevelMark:'',
        drawLevel:'',
        name:'',
        url:'',
      },
      // 0 未中奖 1 一等奖 2 二等奖 3 三等奖
      jplist:[
        {
          drawLevel:'未中奖',
          name:'',
          url:''
        },
      ],
      drawLottery:0,
      images,
      src:'',
    }
  },
  mounted(){
    // this.userWinning = Number(localStorage.drawLottery)
    this.type = this.$route.query.type;//success  fail
    this.score = this.$route.query.score;
    this.drawLottery = this.$route.query.drawLottery||0;
    this.jplist.push(...JSON.parse(localStorage.jp))
    // this.openshow()
  },
  // watch:{
  //   showbm(val){
  //     if(!val){
  //       this.$router.replace({
  //         path:'/',
  //       });
  //     }
  //   }
  // },
  methods: {
    openshow(){
      this.src = this.images[this.getRandomInt(this.images.length)]
      this.showbm=true
    },
    getRandomInt(N) {
        // Math.random() 生成一个 [0, 1) 之间的浮点数
        // 将其乘以 N 并使用 Math.floor() 向下取整，得到一个 [0, N-1] 之间的整数
        // 然后通过加上 0 来确保范围包括 N（如果 N 是你想要的最大值）
        // 但通常我们想要的是 [0, N) 范围，所以直接返回 Math.floor(Math.random() * N)
        // 如果确实需要包括 N（即 [0, N]），并且 N 是正整数，则可以使用以下方式：
        // return Math.floor(Math.random() * (N + 1));
        // 但这里我们按照常规理解，提供 [0, N-1] 的实现
        return Math.floor(Math.random() * N);
    },
    onChange(index) {
      this.src = this.images[index];
    },
    opencj(query){
      let obj = {
        openId:localStorage.q,
      }
      let toast = this.$toast.loading({
        duration:0,
        message: '抽奖中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$store.dispatch('draw',obj).then(res=>{
        // let res = {
        //   obj:{
        //     drawLevelMark:0,
        //     drawLevel:'一等奖',
        //   }
        // }
        this.showbm = true
        let jplist = this.jplist.filter((item,index)=>index == res.obj.drawLevelMark)[0]
        this.zjinfo.drawLevelMark = res.obj.drawLevelMark;
        this.zjinfo.ifzj = res.obj.drawLevelMark != 0;
        this.zjinfo.drawLevel = res.obj.drawLevel
        if(jplist){
          this.zjinfo.name = jplist.name
          this.zjinfo.url = jplist.url
        }
        // localStorage.userWinning = Number(localStorage.userWinning) + 1
        // this.userWinning = Number(localStorage.drawLottery)
        toast.clear()
      }).catch(()=>{
        toast.clear()
        this.$toast.fail('活动太火爆了~稍后再试');
      })
    },
    // 跳转报名
    gobm(){
      this.showbm = false
      this.$router.replace({
        path:'/bm',
      });
    },
    close(){
      this.showbm = false
      debugger
    },
    download(){
      this.showbm = false
      // 创建一个下载链接
      const url = this.src;
      const a = document.createElement('a');
      a.href = url;
      a.download = 'myImage.png'; // 设置下载的文件名
      // 触发下载
      document.body.appendChild(a);
      a.click();
      // 移除下载链接
      document.body.removeChild(a);
    }
  },
}
</script>

<style lang="scss" scoped>
  .dt_wrap{
    // background: url(~@/assets/img/dati_bg.png) center center no-repeat;
    // background-size:cover;
    background-image: linear-gradient(198deg, #00D9FF 0%, #006DFA 42%, #008AF6 86%);
    height: 100vh;
    // min-height: 1448px;
    padding-bottom: 40px;
    padding-top: 240px;
    .tishi{
      width: 642px;
      height: 730px;
      background-image: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 72%, #00D9FF 100%);
      border-radius: 56px;
      margin: 0 auto;
      padding-top: 280px;
      .success_pic{
        width: 404px;
        height: 406px;
        display: block;
        margin: 0 auto 0;
        position: absolute;
        left: calc(50% - 202px);
        top:-138px;
      }
      .content{
        padding: 0 62px;
        &>div{
          width: 100%;
          flex-shrink: 0;
          flex-wrap: 0;
        }
      }
      .btn{
        width: 482px;
        height: 104px;
        background: url(~@/assets/img/cj_btn.png) center center no-repeat;
        background-size: cover;
        color: #ffffff;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 72px auto 0;
      }
      .test{
          margin: 64px auto 0;
          height: 88px;
          h6{
            height: 44px;
            line-height: 44px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 32px;
            color: #666666;
            letter-spacing: 0;
            text-align: center;
          }
      }
      h1{
        height: 60px;
        line-height: 60px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 44px;
        color: #333333;
        letter-spacing: 0;
        margin-top: 12px;
        margin-bottom: 68px;
        text-align: center;
      }
      h2{
        height: 98px;
        line-height:98px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 76px;
        color: #F3703B;
        letter-spacing: 0;
        text-align: center;
      }
      p{
        margin-top: 12px;
        height: 50px;
        line-height:50px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 36px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
      }
    }
    .fail{
      background-image: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 72%, #00D9FF 100%);
      .fail_pic{
        width: 250px;
        height: 304px;
        display: block;
        margin: 0 auto 0;
        position: absolute;
        left: calc(50% - 125px);
        top:-44px;
      }
    }
  }

  
  .overlay{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 20px;
    .btn_wrap{
      width: 650px;
    }
    .guanbi{
      width: 186px;
      height: 90px;
    }
    .baocun{
      width: 454px;
      height: 90px;
    }
  }
  .wrapper{
    width: 650px;
    height: 1200px;
    border-radius: 20px;
    margin-bottom: 20px;
    .haibao_wrap{
      width: 100%;
      height: calc(100% - 50px);
      text-align: center;
    }
    .close{
      width: 30px;
      height: 30px;
      position: absolute;
      right: 40px;
      top: -5px;
    }
    .haibao{
      max-height: 100%;
      margin: 0 auto;
    }
    p{
      font-size: 30px;
      color: #fff;
      text-align: center;
      margin-bottom: 20px;
      line-height: 30px;
      
    }
  }
  /deep/{
  .van-notice-bar__content{
    font-weight: 400;
    font-size: 0.3733rem;
    color: #000000;
    letter-spacing: 0;
  }
    .van-notice-bar{
      height: 1.1467rem;
      padding: 0 0.24rem;
    }
    .van-swipe__indicator{
      border-radius: 0.08rem;
      width: 0.32rem;
      height: 0.16rem;
    }
    .van-swipe__indicator--active{
      width: 0.5067rem;
    }
  }
  .fxhb{
    margin: 40px auto;
    text-align: center;
    width:482px;
    height: 104px;
    position: relative;
    background: url(~@/assets/img/sbtn.png) center center no-repeat;
    background-size: cover;
    p{
      color: #09757f;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 104px;
    }
  }

  
</style>